import { useTranslation } from 'react-i18next';
import { useNoteReceivableFormContext } from '../context';
import { FormFileList, FormFileListProps } from '../../UI/components/Form';

interface NoteReceivableFileListProps extends Pick<FormFileListProps, 'className' | 'withTitle'> {}

export function NoteReceivableFileList(props: NoteReceivableFileListProps) {
  const { t: tForm } = useTranslation('form');
  const { householdID, noteReceivable } = useNoteReceivableFormContext();

  return (
    <FormFileList
      {...props}
      tenantID={householdID}
      itemID={noteReceivable?.id}
      title={tForm('general-related-documents')}
    />
  );
}
